<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-25 14:57:58
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 17:24:50
 * @FilePath: /privacy-web/src/views/HomePage/PrivacyProtectConcept.vue
-->
<template>
  <div
    class="privacy-protect-concept-main"
    :class="{ 'privacy-protect-concept-main-mobile': isMobile }"
  >
    <Base-title class="animate__animated" :class="animated"></Base-title>
    <Privacy-protect-concept-content
      :src="src"
      class="animate__animated"
      :class="animated"
    ></Privacy-protect-concept-content>
    <!-- <GoodNeeds></GoodNeeds> -->
  </div>
</template>
<script>
import BaseTitle from "../../components/Base/BaseTitle.vue";
export default {
  components: { BaseTitle },
  // 贝壳隐私保护理念
  name: "PrivacyProtectConcept",
  props: {
    animated: {
      type: String,
      default: "animate__zoomIn",
    },
    src: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss" scoped>
.privacy-protect-concept-main {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background: #f6faff;
}
.privacy-protect-concept-main-mobile {
  padding-top: 2.1rem;
  padding-bottom: 2.2rem;
}
</style>
